// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w2-8";
export var editMode = "_w2-3";
export var headerRow = "_w2-a";
export var headerTitle = "_w2-b";
export var product = "_w2-1";
export var productDetails = "_w2-5";
export var productDivider = "_w2-7";
export var productImage = "_w2-2";
export var productInfo = "_w2-4";
export var productTitle = "_w2-6";
export var strikethrough = "_w2-9";
export var upsellProductsCard = "_w2-0";